import { create } from "zustand";

const useRolePermissionStore = create((set) => ({
  rolePermissions: [],
  setRolePermissions: (rolePermissions) => set({ rolePermissions }),
}));

export default useRolePermissionStore;
